export const AppBar = () => ({
  defaultProps: {
    color: 'transparent'
  },
  styleOverrides: {
    root: {
      boxShadow: 'none'
    }
  }
});